"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gltf = void 0;
const DRACOLoader_1 = require("three/examples/jsm/loaders/DRACOLoader");
const GLTFLoader_1 = require("three/examples/jsm/loaders/GLTFLoader");
const utils_1 = require("../utils/utils");
class Gltf {
    load(url, loaderManager, tokenProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const loader = new GLTFLoader_1.GLTFLoader(loaderManager);
            const dracoLoader = new DRACOLoader_1.DRACOLoader();
            /**
             * (Optional) Change decoder source directory (defaults to 'https://www.gstatic.com/draco/versioned/decoders/1.4.1/').
             * It is recommended to always pull your Draco JavaScript and WASM decoders from this URL. Users will benefit from having
             * the Draco decoder in cache as more sites start using the static URL.
             */
            dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.4.3/');
            // dracoLoader.setDecoderConfig({ type: 'js' }); // Optional use JS decoder (defaults to WebAssembly if supported)
            loader.setDRACOLoader(dracoLoader);
            if ((0, utils_1.isUrlPrivate)(url)) {
                if (tokenProvider === undefined) {
                    throw new Error("Jwt token calback is not defined");
                }
                const header = { ['Authorization']: 'Bearer ' + tokenProvider() };
                loader.setRequestHeader(header);
            }
            return new Promise((res, rej) => {
                loader.load(url, (gltf) => {
                    dracoLoader.dispose();
                    res(gltf.scene);
                }, (xhr) => {
                    let loading = ((xhr.loaded / xhr.total) * 100).toFixed(2);
                    // console.log(loading + "%");
                }, (err) => {
                    rej(err);
                });
            });
        });
    }
}
exports.Gltf = Gltf;
